import { Box, Modal, IconButton, Typography, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import WrongBrowserImage from "static/svgs/WrongBrowser.svg";

interface UnsupportedBrowserModalProps {
  isOpen: boolean;
  onClose: () => void;
};

const UnsupportedBrowserModal = ({ isOpen, onClose }: UnsupportedBrowserModalProps) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-label="modal-unstable-connection"
        aria-description="A modal informing you that your connection is unstable. You may neeed to connect your device via hard wire."
      >
        <Box sx={{
          position: "relative", backgroundColor: "white", textAlign: "center",
          padding: "28px", width: "500px", minHeight: "374px", top: "50%",
          left: "50%", transform: "translate(-50%, -50%)", borderRadius: "12px",
        }}>
          <IconButton onClick={onClose} sx={{ position: "absolute", width: "24px", height: "24px", right: "24px", top: "19px"}}>
            <CloseIcon />
          </IconButton>

          <Typography sx={{ color: "#455459", fontSize: "18px" }} variant="body1" >{"We\'re sorry, but"}</Typography>
          <Typography sx={{ color: "#455459", fontSize: "18px", fontWeight: "bold", marginBottom: "40px" }} variant="body1" >{"your browser isn\'t supported."}</Typography>

          <img src={WrongBrowserImage} style={{ width: "200px", height: "118px", paddingBottom: "12px" }} />

          <Typography
            sx={{ 
              maxWidth: "300px", color: "#455459", fontSize: "14px", paddingBottom: "40px", textAlign: "center",
              marginLeft: "auto", marginRight: "auto",
            }}
            variant="body1"
          >
            To enjoy our site, try using Google Chrome.
          </Typography>

          <Button
            sx={{ 
              backgroundColor: "#071B22", height: "32px", width: "165px",
              color: "white", fontSize: "14px", textWrap: "nowrap", borderRadius: "8px"
            }}
            onClick={onClose}
          >
            Continue Anyway
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default UnsupportedBrowserModal;